/* global global */
const globalVars = global === 'undefined' ? window : global;

export function use({ application, definition }) {
  if (!globalVars.hasOwnProperty('LEARN_RUNTIME_APPLICATIONS')) {
    globalVars.LEARN_RUNTIME_APPLICATIONS = {};
  }
  globalVars.LEARN_RUNTIME_APPLICATIONS[application] = definition;
}

export function getApplication(name) {
  return globalVars.LEARN_RUNTIME_APPLICATIONS[name];
}



// WEBPACK FOOTER //
// ./jsapp/shared/learnRuntime/applications.js